// Mixed-direction text (ADR-082): names people typed are isolated with <bdi> so a French name never reorders an Arabic line;
// record numbers, barcodes and codes always read left to right.
import type { ReactNode } from 'react';

/** A name or free text a user typed (customer, product, Seller). Never translated. */
export function Name({ children }: { children: ReactNode }) {
  return <bdi>{children}</bdi>;
}

/** A record number, barcode, SKU or VIN: monospaced, left to right, isolated. */
export function Code({ children }: { children: ReactNode }) {
  return (
    <span className="yv-code" dir="ltr">
      {children}
    </span>
  );
}
